import Cookies from 'js-cookie'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

export default {
  _instance: null,
  messages: window.config.locales_terms ?? {},
  install() {
    Vue.use(VueI18n)
    Vue.component('i18n').options.props = {
      ...Vue.component('i18n').options.props,
      displayHtmlTags: {
        type: Boolean,
        required: false,
        default: false,
      },
    }
    Vue.component('i18n').options.render = function (h, ref) {
      var data = ref.data
      var parent = ref.parent
      var props = ref.props
      var slots = ref.slots

      var $i18n = parent.$i18n
      if (!$i18n) {
        return
      }

      var path = props.path
      var locale = props.locale
      var params = slots()
      var children = $i18n.i(path, locale, params)

      var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span'

      if (props.displayHtmlTags) {
        let fn = (item) => (typeof item === 'string' ? h('span', { domProps: { innerHTML: item } }) : item)

        children = Array.isArray(children) ? children.map(fn) : [children].map(fn)
      }

      return tag ? h(tag, data, children) : children
    }
  },
  getInstance() {
    if (!this._instance) {
      let fallbackLocale = 'en'
      let locale

      if (Cookies.get('zendrop-lang')) {
        locale = Cookies.get('zendrop-lang')
      } else if (document.documentElement.lang) {
        locale = document.documentElement.lang
      } else {
        locale = window.navigator.language.startsWith('pt') ? 'pt-BR' : fallbackLocale
      }

      // Accept only presented locales
      if (!window.config.locales_terms || !Object.keys(window.config.locales_terms).includes(locale)) {
        locale = fallbackLocale
      }

      this._instance = new VueI18n({
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: this.messages,
      })
    }

    return this._instance
  },
}
